var map = {
	"./dot-blue.svg": 25832,
	"./map-pin-cluster.svg": 69023,
	"./map-pin-filled.svg": 56331,
	"./map-pin-location.svg": 96554,
	"./map-pin-outlined.svg": 95377,
	"./map-pin-white-dot-large.svg": 9826,
	"./map-pin-white-dot-small.svg": 3686
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60991;